import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { UnstyledLink } from '../../link';

import { blueLink } from '@zocdoc/branding/colors';

const FALLBACK = {};

/**
 * A component that listens for the "lock" context option and renders as
 * non-interactable elements in that case instead of clickable links.
 *
 * @param {object} props
 * @param {string} href - the link destination
 */
function LockableLink({ href, ...props }, { lock } = FALLBACK) {
    return lock ? (
        <span {...props} />
    ) : (
        <UnstyledLink
            href={href}
            {...props}
        >{props.children}
        </UnstyledLink>
    );
}

LockableLink.contextTypes = {
    lock: PropTypes.bool,
};

const StyledLockableLink = styled(LockableLink)`
    color: ${blueLink};
`;

export default StyledLockableLink;
